document.addEventListener("DOMContentLoaded", () => {

    "use strict";


    /*==================================================
      CONFIGURACIÓN
    ==================================================*/

    const STORAGE_KEY = "cp-contact-form";

    const form = document.getElementById("cp-form");

    if (!form) return;

    const endpoint = form.dataset.endpoint || "";
    const siteKey = form.dataset.sitekey || "";
    const formName = form.dataset.formName || "";

    let captchaWidgetId = null;
    let sending = false;

    /*==================================================
      CAMPOS
    ==================================================*/

    const token = document.getElementById("cp-token");

    const name = document.getElementById("cp-name");
    const email = document.getElementById("cp-email");
    const phone = document.getElementById("cp-phone");
    const subject = document.getElementById("cp-subject");
    const message = document.getElementById("cp-message");

    const fields = [
        name,
        email,
        phone,
        subject,
        message
    ];

    /*==================================================
      ELEMENTOS
    ==================================================*/

    const progressBar =
        document.querySelector(".cp-progress-bar");

    const progressPercent =
        document.querySelector(".cp-progress-percent");

    const counter =
        document.querySelector(".cp-counter");

    const successBox =
        document.querySelector(".cp-success-message");

    const errorBox =
        document.querySelector(".cp-error-message");

    const toast =
        document.getElementById("cp-toast");

    const submitButton =
        document.querySelector(".cp-button");

    const honeypot =
        document.querySelector('input[name="website"]');

    /*==================================================
      UTILIDADES
    ==================================================*/

    function hideMessages(){

        if(successBox)
            successBox.hidden = true;

        if(errorBox)
            errorBox.hidden = true;

    }

    function showSuccess(){

        hideMessages();

        if(successBox){

            successBox.hidden = false;

            setTimeout(() => {

                successBox.scrollIntoView({

                    behavior:"smooth",

                    block:"center"

                });

            },100);

        }

    }

    function updateRequestInformation(result){

    const requestId =
        document.getElementById("cp-request-id");

    const requestDate =
        document.getElementById("cp-request-date");

    if(requestId){

        requestId.textContent =
            result.requestId || "-";

    }

    if(requestDate){

        if(!result.sentAt){

            requestDate.textContent = "-";

            return;

        }

        const date = new Date(result.sentAt);

        requestDate.textContent =
            date.toLocaleString(
                "es-CO",
                {
                    dateStyle:"long",
                    timeStyle:"short",
                    timeZone:"America/Bogota"
                }
            );

    }

}

                    function trackLeadConversion(result){

                        const eventData={

                            form_name:"Formulario Premium",

                            request_id:result.requestId || "",

                            page_title:document.title,

                            page_location:window.location.href,

                            language:document.documentElement.lang || navigator.language,

                            success:true

                        };

                        if(typeof gtag==="function"){


                            gtag(
                                "event",
                                "generate_lead",
                                eventData
                            );

                        }

                        if(typeof fbq==="function"){

                            fbq(
                                "track",
                                "Lead",
                                {

                                    content_name:"Formulario Premium",

                                    request_id:result.requestId || ""

                                }
                            );

                        }

                    }  

    function showError(){

        hideMessages();

        if(errorBox)
            errorBox.hidden = false;

    }

    function loadingButton(state){

        if(!submitButton) return;

        submitButton.disabled = state;

        if(state){

            submitButton.dataset.text =
                submitButton.innerHTML;

            submitButton.innerHTML = `
                <span class="cp-spinner"></span>
                Enviando...
            `;

        }else{

            submitButton.innerHTML =
                submitButton.dataset.text;

        }

    }

    function showToast(type,message){

        if(!toast) return;

        toast.className =
            "cp-toast show " + type;

        const text =
            toast.querySelector(".cp-toast-text");

        const icon =
            toast.querySelector(".cp-toast-icon");

        if(text)
            text.textContent = message;

        if(icon){

            icon.textContent =
                type === "success"
                ? "✔"
                : "✖";

        }

        clearTimeout(window.toastTimer);

        window.toastTimer =
            setTimeout(()=>{

                toast.classList.remove("show");

            },3500);

    }

    function clearStatus(field){

        const status =
            field.parentNode.querySelector(".cp-status");

        const icon =
            field.parentNode.querySelector(".cp-field-icon");

        field.classList.remove(
            "cp-valid",
            "cp-invalid"
        );

        if(icon){

            icon.classList.remove(
                "cp-valid",
                "cp-invalid"
            );

        }

        if(status){

            status.innerHTML = "";

            status.classList.remove(
                "cp-success",
                "cp-error"
            );

        }

    }

    function setStatus(field,ok,text){

        const status =
            field.parentNode.querySelector(".cp-status");

        const icon =
            field.parentNode.querySelector(".cp-field-icon");

        clearStatus(field);

        if(ok){

            field.classList.add("cp-valid");

            if(icon)
                icon.classList.add("cp-valid");

            if(status){

                status.classList.add("cp-success");

                status.innerHTML =
                    `<span class="cp-icon">✔</span>${text}`;

            }

        }else{

            field.classList.add("cp-invalid");

            if(icon)
                icon.classList.add("cp-invalid");

            if(status){

                status.classList.add("cp-error");

                status.innerHTML =
                    `<span class="cp-icon">✖</span>${text}`;

            }

        }

    }
        /*==================================================
      VALIDACIONES
    ==================================================*/

    function validateName(){

        const value = name.value.trim();

        if(value === ""){

            setStatus(name,false,"Este campo es obligatorio.");
            return false;

        }

        if(value.length < 3){

            setStatus(name,false,"Debe contener mínimo 3 caracteres.");
            return false;

        }

        if(!/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(value)){

            setStatus(name,false,"Solo se permiten letras.");
            return false;

        }

        setStatus(name,true,"Nombre correcto.");

        return true;

    }

    function validateEmail(){

        const value = email.value.trim();

        if(value === ""){

            setStatus(email,false,"Este campo es obligatorio.");
            return false;

        }

        const regex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if(!regex.test(value)){

            setStatus(email,false,"Correo electrónico inválido.");
            return false;

        }

        setStatus(email,true,"Correo válido.");

        return true;

    }

    function validatePhone(){

        const value = phone.value.trim();

        if(value === ""){

            setStatus(phone,false,"Este campo es obligatorio.");
            return false;

        }

        const digits =
            value.replace(/\D/g,"");

        if(digits.length < 10){

            setStatus(phone,false,"Debe contener mínimo 10 dígitos.");
            return false;

        }

        if(digits.length > 15){

            setStatus(phone,false,"Máximo 15 dígitos.");
            return false;

        }

        setStatus(phone,true,"Teléfono válido.");

        return true;

    }

    function validateMessage(){

        const value = message.value.trim();

        if(value === ""){

            setStatus(message,false,"Este campo es obligatorio.");
            return false;

        }

        if(value.length < 20){

            setStatus(message,false,"Debe contener mínimo 20 caracteres.");
            return false;

        }

        if(value.length > 1000){

            setStatus(message,false,"Máximo 1000 caracteres.");
            return false;

        }

        setStatus(message,true,"Mensaje correcto.");

        return true;

    }

    /*==================================================
      CONTADOR
    ==================================================*/

    function updateCounter(){

        if(!counter) return;

        counter.textContent =
            `${message.value.length} / 1000`;

    }

    /*==================================================
      PROGRESO
    ==================================================*/

    function refreshProgress(){

        let total = 5;

        let valid = 0;

        if(validateName()) valid++;

        if(validateEmail()) valid++;

        if(validatePhone()) valid++;

        if(validateMessage()) valid++;

        if(policyCheck.checked){

            valid++;

        }

        const percent =
            Math.round((valid / total) * 100);

        if(progressBar){

            progressBar.style.width =
                percent + "%";

        }

        if(progressPercent){

            progressPercent.textContent =
                percent + "%";

        }

}

/*==================================================
POLÍTICA DE DATOS
==================================================*/

const policyCheck = document.getElementById("cp-policy-check");

const policyError = document.querySelector(".cp-policy-error");


    /*==================================================
      LOCAL STORAGE
    ==================================================*/

    function saveForm(){

        localStorage.setItem(

            STORAGE_KEY,

            JSON.stringify({

                name:name.value,

                email:email.value,

                phone:phone.value,

                subject:subject.value,

                message:message.value,

                policy:policyCheck.checked

            })

        );

    }

    function loadForm(){

        const saved =
            localStorage.getItem(STORAGE_KEY);

        if(!saved) return;

        const data =
            JSON.parse(saved);

        name.value =
            data.name || "";

        email.value =
            data.email || "";

        phone.value =
            data.phone || "";

        subject.value =
            data.subject || "";

        message.value =
            data.message || "";

        policyCheck.checked =
            data.policy || false;
            refreshProgress();

    }

    function clearFormStorage(){

        localStorage.removeItem(STORAGE_KEY);

    }

        fields.forEach(field=>{

            field.addEventListener("input",()=>{

                saveForm();

                updateCounter();

                refreshProgress();

            });

        });
    name.addEventListener("blur",validateName);

    email.addEventListener("blur",validateEmail);

    phone.addEventListener("blur",validatePhone);

    message.addEventListener("blur",validateMessage);

        policyCheck.addEventListener("change",()=>{

            saveForm();

            refreshProgress();

            policyError.classList.remove("show");

            policyError.textContent="";

        });

        /*==================================================
      SEGURIDAD
    ==================================================*/

    function validateHoneypot(){

        if(!honeypot) return true;

        return honeypot.value.trim()==="";

    }

    function canSend(){

        if(sending){

            showToast(
                "error",
                "Ya existe un envío en proceso."
            );

            return false;

        }

        return true;

    }

    /*==================================================
      API
    ==================================================*/

async function sendForm(formData){

    if(endpoint === ""){

        throw new Error("Endpoint no configurado.");

    }

    const response = await fetch(endpoint,{

        method:"POST",

        body:formData

    });

    const result = await response.json();

    if(!response.ok){

        throw new Error(

            result.message ||

            "Error del servidor."

        );

    }

    return result;

}

    /*==================================================
      ENVÍO
    ==================================================*/

    async function processSubmit(){


    sending = true;

    loadingButton(true);

    try{

        const departmentSelect = document.getElementById("cp-department");

        const selectedOption =
            departmentSelect?.options[departmentSelect.selectedIndex];


const customFields = [];

document
    .querySelectorAll("[id^='cf-']")
    .forEach(field => {

        customFields.push({

            id: field.name,

            label: document.querySelector(
                `label[for="${field.id}"]`
            )?.textContent.trim() || "",

            value: field.value

        });

    });


    const formData = new FormData(form);

        const payload = {

            name: name.value.trim(),

            email: email.value.trim(),

            phone: phone.value.trim(),

            subject: subject.value.trim(),

            message: message.value.trim(),

            department: departmentSelect?.value || "",

            destination: selectedOption?.dataset.email || "",

            formName,

            customFields,

            token: token.value,

            policy: policyCheck.checked,

            url: window.location.href,

            language: navigator.language,

            userAgent: navigator.userAgent,

            timezone:
                Intl.DateTimeFormat()
                    .resolvedOptions()
                    .timeZone,

            sentAt: new Date().toISOString()

        };


Object.entries(payload).forEach(([key, value]) => {

    if (

        key !== "customFields" &&

        value !== undefined &&

        value !== null

    ) {

        formData.set(key, value);

    }

});

formData.set(

    "customFields",

    JSON.stringify(payload.customFields)

);

const result = await sendForm(formData);

        updateRequestInformation(result);

        if(result.success){

            clearFormStorage();

            form.reset();

            token.value = "";

            updateCounter();

            trackLeadConversion(result);

            refreshProgress();

            hideMessages();

            showSuccess();

            showToast(
                "success",
                result.message ||
                "Mensaje enviado correctamente."
            );

            if(typeof hcaptcha !== "undefined"
            && captchaWidgetId !== null){

                hcaptcha.reset(
                    captchaWidgetId
                );

            }

        }else{

            hideMessages();

            showError();

            showToast(
                "error",
                result.message ||
                "No fue posible enviar."
            );

        }

    }catch(error){

        console.error(error);

        hideMessages();

        showError();

        showToast(
            "error",
            error.message ||
            "No fue posible conectar con el servidor."
        );

    }finally{

        sending = false;

        loadingButton(false);

    }

}
        /*==================================================
      HCAPTCHA
    ==================================================*/

    function initHCaptcha(){

        if(!siteKey){

            console.warn("Site Key no configurada.");

            return;

        }

        if(typeof hcaptcha === "undefined"){

            console.warn("hCaptcha aún no cargó.");

            return;

        }

        const container =
            document.getElementById("cp-hcaptcha");

        if(!container){

            console.warn("No existe cp-hcaptcha.");

            return;

        }

        captchaWidgetId = hcaptcha.render(container,{

            sitekey:siteKey,

            size:"invisible",

            callback:async function(tokenValue){

                token.value = tokenValue;

                await processSubmit();

            },

            "expired-callback":function(){

                token.value="";

                showToast(
                    "error",
                    "La validación expiró."
                );

            },

            "error-callback":function(){

                token.value="";

                showToast(
                    "error",
                    "No fue posible validar la seguridad."
                );

            }

        });

    }

    /*==================================================
      SUBMIT
    ==================================================*/

    form.addEventListener("submit",async function(e){

        e.preventDefault();

        hideMessages();

        policyError.classList.remove("show");

            policyError.textContent = "";

            if(!policyCheck.checked){

                policyError.textContent =
                "Debes aceptar la Política de Tratamiento de Datos para continuar.";

                policyError.classList.add("show");

                policyCheck.focus();

                showToast(
                    "error",
                    "Debes aceptar la Política de Tratamiento de Datos."
                );

                return;

            }

        if(!validateName()
        || !validateEmail()
        || !validatePhone()
        || !validateMessage()){

            refreshProgress();

            showToast(
                "error",
                "Hay campos por corregir."
            );

            const firstError =
                form.querySelector(".cp-invalid");

            if(firstError){

                firstError.focus();

                firstError.scrollIntoView({

                    behavior:"smooth",

                    block:"center"

                });

            }

            return;

        }

        if(!validateHoneypot()){

            showToast(
                "error",
                "Solicitud inválida."
            );

            return;

        }

        if(!canSend()){

            return;

        }

        if(captchaWidgetId===null){

            showToast(
                "error",
                "hCaptcha aún no está listo."
            );

            return;

        }

        token.value="";

        hcaptcha.execute(captchaWidgetId);

    });

/*==================================================
  INICIALIZACIÓN
==================================================*/

loadForm();

updateCounter();

/* Solo actualizar la barra si ya existen datos */
if(
    name.value.trim() ||
    email.value.trim() ||
    phone.value.trim() ||
    message.value.trim()
){
    refreshProgress();
}

setTimeout(function(){

    initHCaptcha();

},300);

/*==================================================
  MÓDULOS
==================================================*/

if (window.CP?.initFileUpload) {

    window.CP.initFileUpload();

}

});